import styled from 'styled-components';

export const SkeletonTitle = styled.div`
    width: 20%;
    margin-bottom: 20px;
`;

export const SkeletonOptionWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
`;

export const SkeletonOption = styled.div`
    width: 25%;
`;
